import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import HRLogo from '../assets/ThinkHR_Logo-removebg-preview.png'; // Adjust the path as necessary
import ThinkHRImage from '../assets/HR - Executive Summary.png';

const ThinkHR = () => {
  const navigate = useNavigate();
  const sectionRef = useRef(null);
  const imageRef = useRef(null);
  const titleRef = useRef(null);
  const iconRef = useRef(null);
  const descriptionOneRef = useRef(null);
  const descriptionTwoRef = useRef(null);
  const buttonRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-in');
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      }
    );

    // Observe all animated elements
    const elementsToObserve = [
      imageRef.current,
      titleRef.current,
      iconRef.current,
      descriptionOneRef.current,
      descriptionTwoRef.current,
      buttonRef.current
    ];

    elementsToObserve.forEach((element) => {
      if (element) {
        observer.observe(element);
      }
    });

    return () => observer.disconnect();
  }, []);

  const handleNavigate = (path) => {
    navigate(path);
    window.scrollTo(0, 0);
  };

  return (
    <section className="think-hr" ref={sectionRef}>
      <div className="container think-hr-container">
        <div 
          className="section-image-hr think-hr-graph slide-in-left" 
          ref={imageRef}
        >
          <img src={ThinkHRImage} alt='ThinkHR' className="think-hr-image"/>
        </div>
        <div className="section-content">
          
          {/* Updated: Wrap logo and subtitle in a container */}
          <div 
            className="product-header slide-in-right" 
            ref={titleRef}
            style={{ animationDelay: '0.2s' }}
          >
            <div className="hr-logo-with-underline">
            <img 
              className="hr-home-product-title"
              src={HRLogo}
              alt="ThinkHR Logo"
            />
            </div>
            
            <span className="hr-home-product-subsubtitle">
               Comprehensive workforce insights at your fingertips, making HR efficient
               </span>
          </div>
          
          <div className="icon-container">
            {/* Icon content if needed */}
          </div>
          
          <p 
            className="hr-home-product-description-one fade-in-up" 
            ref={descriptionOneRef}
            style={{ animationDelay: '0.6s' }}
          >
            Gone are the days when compiling HR reports took several days of painstaking effort.
            <p> Now, you can instantly access comprehensive workforce data with just a few clicks. Imagine being able to see employee attrition predictions, forecast leave patterns to avoid quarter-end disruptions and analyse pay scales across different departments – all at the tip of your fingers.</p>
          </p>
          <p 
  className="hr-home-product-description-two fade-in-up" 
  ref={descriptionTwoRef}
  style={{ animationDelay: '0.8s' }}
>
  ThinkHR not only saves valuable time but also empowers you to manage HR challenges proactively. Embrace the future of HR management, where insights are readily available and actionable, transforming how you understand and manage your workforce.
</p>
          <button 
            className="explore-button slide-in-up" 
            onClick={() => handleNavigate('/thinkhr')}
            ref={buttonRef}
            style={{ animationDelay: '1.0s' }}
          >
            Explore Talent Analytics
          </button>
        </div>
      </div>
    </section>
  );
};

export default ThinkHR;